import ContextMenu from './ContextMenu';
import Menu from './ContextMenuMenu';
import Group from './ContextMenuGroup';
import Item from './ContextMenuItem';
import Trigger from './ContextMenuTrigger';

ContextMenu.Menu = Menu;
ContextMenu.Group = Group;
ContextMenu.Item = Item;
ContextMenu.Trigger = Trigger;

export default ContextMenu;
export { Menu, Group, Item, Trigger };
